import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConstant } from '@app/app.constant';
import { OrganizationApiService } from '@shared/services/organization-api.service';
import { GlobalService } from '../services/global.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class OrganizationResolver  {
    constructor(
        private router: Router,
        private globalService: GlobalService,
        private organizationApiService: OrganizationApiService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.organizationApiService.getDetail().pipe(map(data => {
            this.globalService.storage.add(AppConstant.GLOBAL_STORAGE.ORGANIZATION, data);
            this.globalService.storage.add(AppConstant.GLOBAL_STORAGE.BUSINESS_UNITS, data.businessUnits);
            const currentBU = data.businessUnits.find(item => item.isActive);
            if (currentBU) {
                this.globalService.storage.add(AppConstant.GLOBAL_STORAGE.BUSINESS_UNIT, currentBU);
            }
        }), catchError(error => {
            return this.router.navigateByUrl('initiation/setup-account');
        }));
    }
}
